// Librerias
import React from 'react'
import api from '../apiClient/v1'
let PropTypes = React.PropTypes
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as css from './modal.css'
let cx = classNames.bind(css)

// function as a children FTW! :D
export class ModalTrigger extends React.Component {
    constructor(props) {
        super(props)
        this.state = { visible: false }
        let self = this
        this.show = () =>
            self.setState({ visible: true })
        this.hide = () => {
            self.setState({ visible: false })
        }
    }
    render() {
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalConfirmar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.cancelModal} /*className={cx('modal')} dialogClassName={cx('modalUser')}*/>
                <Modal.Header closeButton>
                    <Modal.Title>Favor confirme su registro</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 style={{ textAlign: 'center' }}>Verifique si sus datos son correctos antes de confirmar</h4>
                    <hr />
                    <div style={{ textAlign: 'center' }}>
                        <div className={cx('tab')}>
                            <b>RUN:</b> {this.props.datos.usuarioRUN}-{this.props.datos.usuarioDV}<br />
                            <b>Nombre:</b> {this.props.datos.nombre1 + " " + this.props.datos.nombre2 + " " + this.props.datos.apellidoPaterno + " " + this.props.datos.apellidoMaterno}
                            <br />
                        </div>
                        <div className={cx('tab')}>
                            <b>Fecha nacimiento:</b> {this.props.datos.fechaNacimiento ? this.props.datos.fechaNacimiento.toLocaleDateString() : this.props.datos.fechaNacimiento}<br />
                            <b>Sexo:</b> {this.props.datos.sexo}<br />
                            <b>Nacionalidad:</b> {this.props.datos.otraNacionalidad ? this.props.datos.otraNacionalidad : this.props.datos.nacionalidad}
                        </div>
                        <div className={cx('tab')}>
                            <b>Teléfono:</b> {this.props.datos.telefonoEmergencia != "" ? this.props.datos.telefono + " - " + this.props.datos.telefonoEmergencia : this.props.datos.telefono}<br />
                            <b>Email:</b> {this.props.datos.emailPersonal}<br />
                            <b>Comuna:</b> {this.props.comuna.nombre}<br />
                            <b>Región:</b> {this.props.region.nombre}<br />
                            <b>Dirección:</b> {this.props.datos.direccion}<br />
                            <b>Captador:</b> {this.props.captador.nombre}
                        </div>
                        <div>
                            <b>Banco:</b> {this.props.banco.nombreCorto}<br />
                            <b>Tipo cuenta:</b> {this.props.cuenta.nombreCuenta}<br />
                            <b>Número cuenta:</b> {this.props.datos.numeroCuenta}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div style={{ textAlign: 'center' }}>
                        Después de confirmar, podrá subir fotos o imágenes de su documento de identidad
                    </div> <br />
                    <button className='btn btn-warning' onClick={this.props.cancelModal}>
                        Cancelar
                    </button>
                    <button className='btn btn-success' onClick={() => this.props.confirmar(this.props.datos)} disabled={this.props.confirmando}>
                        Confirmar
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export class ModalUploadFiles extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            frontDNI: '',
            backDNI: '',
            fechaVenc: '',
            fecha: '',
            boton: false,
            certificatePersonalHistory: '',
            contract: '',
            credential: '',
            completededDocumentation: this.props.user.statusFiles === 'Cargados',
            existingCarnetFront: this.props.user.existingCarnetFront,
            existingCarnetBack: this.props.user.existingCarnetBack
        }
        this.onChangeDNIFront = (evt) => {
            this.setState({
                frontDNI: evt.target.files[0]
            }, () => this.context.uploadDNIFront(this.props.user.id, this.state.frontDNI))
        }
        this.onChangeDNIBack = (evt) => {
            this.setState({
                backDNI: evt.target.files[0]
            }, () => this.context.uploadDNIBack(this.props.user.id, this.state.backDNI))
        }
        this.fechaDNI = (evt) => {
            evt.preventDefault()
            this.setState({
                fechaVenc: this.state.fecha
            }, () => this.context.uploadFechaVenc(this.props.user.id, this.state.fechaVenc, evt))
        }
        this.onChangeCertificate = (evt) => {
            this.setState({
                certificatePersonalHistory: evt.target.files[0]
            }, () => this.context.uploadCertificate(this.props.idUsuario, this.state.certificatePersonalHistory))
        }
        this.onChangeContract = (evt) => {
            this.setState({
                contract: evt.target.files[0]
            }, () => this.context.uploadContract(this.props.idUsuario, this.state.contract))
        }
        this.onChangeCredential = (evt) => {
            this.setState({
                credential: evt.target.files[0]
            }, () => this.context.uploadCredential(this.props.idUsuario, this.state.credential))
        }
        this.onChangeProgress = () => {
            let status = !this.state.completededDocumentation
            let request = this.context.progressStatusDocumentation(this.props.idUsuario, status)
            request
                .then(files => {
                    this.setState({ completededDocumentation: status })
                })
                .catch(() => {
                    console.log("error")
                })
        }
        this.handleFecha = (event) => {
            this.setState({ fecha: event.target.value, boton: true });
        }
    }
    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.cancelModal} className={cx('modal')}>
                <Modal.Header closeButton>
                    <Modal.Title>Subir documentos de usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {//console.log(this.state.fecha)
                    }
                    <div className={cx('btn-group-vertical', 'div-option-file')}>
                        <button className={cx(this.props.checkFront ? 'btn btn-success' : 'btn btn-warning', 'btn-file')} disabled={this.state.completededDocumentation}>
                            {this.props.checkFront ? 'Reemplazar ' : 'Subir '}Imagen Carnet Frontal<input type="file" accept='image/*' onChange={this.onChangeDNIFront} />
                        </button>
                        <button className={cx(this.props.checkBack ? 'btn btn-success' : 'btn btn-warning', 'btn-file')} disabled={this.state.completededDocumentation}>
                            {this.props.checkBack ? 'Reemplazar ' : 'Subir '}Imagen Carnet Posterior<input type="file" accept='image/*' onChange={this.onChangeDNIBack} />
                        </button>
                    </div>
                    {//this.props.checkFront && this.props.checkBack ? 
                        <div style={{ textAlign: 'center', marginTop: '5px' }}>
                            <form onSubmit={this.fechaDNI}>
                                <label>Fecha de Vencimiento: </label>
                                <input type='date' value={this.state.fecha} onChange={this.handleFecha} format='D-M-YYYY' style={{ margin: '5px' }} />
                                <input type='submit' value='Subir Fecha' style={{ margin: '5px' }} disabled={!this.state.boton} />
                            </form>
                        </div> //: null
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' >
                        <a href='/' style={{ color: 'white' }}>Finalizar Registro</a>
                    </button>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalUploadFiles.contextTypes = {
    uploadDNIFront: PropTypes.func,
    uploadDNIBack: PropTypes.func,
    uploadFechaVenc: PropTypes.func,
    uploadCertificate: PropTypes.func,
    uploadContract: PropTypes.func,
    uploadCredential: PropTypes.func,
    progressStatusDocumentation: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/registro-operador/Modals.jsx